import React, { FC } from 'react';
import { Text, View } from '@react-pdf/renderer';
import { displayPriceFormat, displayVariableValue } from '../../utils/tools';
import { styles } from './InvoiceDocumentFeeItem.styles';
import { InvoiceLine } from '../../models/Invoice';
import { getLabelFromSectionType } from './InvoiceDocumentFeeItem.service';

type Props = {
    line: InvoiceLine;
    volumeLabel: string;
    isExternalDelivery: boolean;
    displaySubTotal: boolean;
    sectionType: string
};

const InvoiceDocumentFeeItemView: FC<Props> = ({
    line,
    volumeLabel,
    isExternalDelivery,
    displaySubTotal,
    sectionType
}) => {
    const nb = line.nbOrder ?? 0;
    const totalHt = line.totalHt ?? 0;

    if (isExternalDelivery) {
        const vatRate = line.vatRate ?? 0;
        const vatLabel = vatRate === 0 ? ' (TVA 0%)' : '';

        return (
            <View style={styles.container}>
                <View style={styles.positionRow}>
                    <View style={styles.leftPart}>
                        <View style={[styles.tableau, styles.border]}>
                            <Text style={styles.labelTab}>Nombre de livraisons{vatLabel}</Text>
                            <Text style={styles.labelTab}>{nb}</Text>
                        </View>
                    </View>

                    <View style={styles.rightPart}>
                        <View style={[styles.tableau, styles.border]}>
                            <Text style={styles.labelTab}>{'\u00A0'}</Text>
                        </View>
                    </View>
                </View>
            </View>
        );
    }

    const sp = line.servicePrice;
    const fixe = sp?.fixe ?? 0;
    const variable = sp?.variable ?? 0;

    const totalFixeHt = sp?.totalFixeHt ?? (nb * fixe);
    const totalVariableHt = sp?.totalVariableHt ?? Math.max(0, totalHt - totalFixeHt);

    const volumeRef = line.amountRefTotal ?? 0;

    return (
        <View style={styles.container}>
            <View style={styles.positionRow}>
                <View style={styles.leftPart}>
                    <View style={styles.tableau}>
                        <Text style={styles.labelTab}>{volumeLabel}</Text>
                        <Text style={styles.labelTab}>{displayPriceFormat(volumeRef)}</Text>
                    </View>

                    <View style={[styles.tableau, styles.border]}>
                        <Text style={styles.labelTab}>{getLabelFromSectionType(sectionType)}</Text>
                        <Text style={styles.labelTab}>{nb}</Text>
                    </View>
                    {displaySubTotal && (
                        <View style={[styles.underTab, styles.border]}>
                            <Text style={styles.labelTab}>{'\u00A0'}</Text>
                            <Text style={styles.labelTab}>{'\u00A0'}</Text>
                        </View>
                    )}
                </View>

                <View style={styles.rightPart}>
                    <View style={styles.tableau}>
                        <Text style={styles.labelTab}>{`${displayVariableValue(variable)} %`}</Text>
                        <Text style={styles.labelTab}>{displayPriceFormat(totalVariableHt)}</Text>
                    </View>

                    <View style={[styles.tableau, styles.border]}>
                        <Text style={styles.labelTab}>{displayPriceFormat(fixe)}</Text>
                        <Text style={styles.labelTab}>{displayPriceFormat(totalFixeHt)}</Text>
                    </View>

                    {displaySubTotal && <View style={[styles.underTab, styles.border]}>
                        <Text style={styles.labelTab}>Sous-total HT</Text>
                        <Text style={styles.labelTab}>{displayPriceFormat(totalHt)}</Text>
                    </View>}
                </View>
            </View>
        </View>
    );
};

export default InvoiceDocumentFeeItemView;
